<template>
  <div class="myteam">
    <toptitle :title1="titlework" />
    <form v-if="blockShow == 3?false:true"
          action="/">
      <van-search v-model="value"
                  placeholder="请搜索用户"
                  @input="inputSearch"
                  :show-action="blockShow == 2 ? true : false">
        <template #action>
          <div @click="onCancel">取消</div>
        </template>
      </van-search>
    </form>
    <department v-if="show"
                :departmentData="department"
                @chooseDept="chooseDept"></department>

    <Index v-if="blockShow == 1"
           :subBody="subBody"
           @chooseItem="chooseItem" />
    <List v-else-if="blockShow == 2"
          :list="subBody"
          @chooseItem="chooseItem" />
    <Result v-else-if="blockShow == 3"
            :list="obj"
            @goBack="goBack" />

    <!-- 历史搜索 -->
    <history :historyData="hislist"
             :show="show"></history>

  </div>
</template>

<script>
import { Toast } from 'vant'
import toptitle from '../../components/toptitle'
import { debounce1 } from '../../utils/throttle'
import {
  GetMyTeamDataApi,
  getMyDeptDataApi,
  getMyTeamIndexApi,
} from '../../request/api'
import Department from '../../components/myteam/department'
import history from '../../components/myteam/history'
import Index from '../../components/myteam/index'
import List from '../../components/myteam/List'
import Result from '../../components/myteam/result'
export default {
  name: 'myteam',
  data() {
    return {
      titlework: '我的团队',
      value: '',
      departmentStr: '',
      loading: false,
      loadFinished: false,
      currentPageNo: 1,
      maxPageNo: 0,
      subBody: [],
      department: [],
      blockShow: 1,
      // 显示隐藏
      show: true,
      // 搜索历史列表
      hislist: [],
      obj: {},
    }
  },
  mounted() {
    this.getDeptList()
  },
  methods: {
    /**
     * 部门获取
     * **/
    getDeptList() {
      let params = {
        EMPLID: sessionStorage.getItem('EMPLID'),
      }
      getMyDeptDataApi(params).then((res) => {
        if (res.CODE === 200) {
          this.departmentStr = res.DEPT
          this.department = res.DATA
          this.getList('', '10000')
        }
      })
    },
    goBack() {
      this.getList('', '10000')
      this.show = true
      this.blockShow = 1
    },
    inputSearch: debounce1(function (e) {
      this.currentPageNo = 1

      if (this.value.length > 0) {
        this.show = false
        this.getList(this.value, '15')
      } else {
        this.show = true
        this.subBody = []
      }
      this.blockShow = 2
    }),

    onCancel() {
      this.value = ''
      this.show = true
      this.getList('', '10000')
      this.blockShow = 1
    },
    /**
     * 部门选择
     *  **/
    chooseDept(val) {
      let subDept = val.SUB
      if (subDept === 'Y') {
        this.$router.push({
          path: '/subdepartment',
          params: {
            // 进入页面的标记
            routerType: 'push',
          },
          query: {
            DEPTID: val.DEPTID,
            companyTitle: val.DEPT_DESCR,
            EMPLID: val.EMPLID,
            subStatus: val.SUB,
          },
        })
      } else {
        this.$router.push({
          path: '/teamemployees',
          query: {
            DEPTID: val.DEPTID,
            EMPLID: val.EMPLID,
            companyTitle: val.DEPT_DESCR,
          },
        })
      }
    },
    /**
     * 获取查看团队成员信息
     *  **/
    chooseItem(val) {
      this.obj = val

      // //如果有的话就删除重复
      this.hislist.forEach((item) => {
        if (item.EMPLID == this.obj.EMPLID) {
          this.hislist.splice(this.hislist.indexOf(item), 1) //this.hislist.indexOf(item) 可以找到它的下标
        }
      })
      //向数组第一位添加
      this.hislist.unshift(this.obj)

      //如果数组长度大于四，就删除最后一项
      if (this.hislist.length > 4) {
        this.hislist.splice(5, 1)
      }
      this.hislist.forEach((item) => {
        item.PHOTO = item.PHOTO.replace(/<br>/g, '')
      })
      //本地存储历史记录数组
      localStorage.hislist = JSON.stringify(this.hislist)
      this.show = false
      this.value = ''
      this.blockShow = 3
    },
    loadMore() {
      if (this.currentPageNo > this.maxPageNo) {
        //已经加载到了最后一页
        this.loadFinished = true
      } else {
        //加载下一页的数据
        this.currentPageNo++
        this.getList('', 15)
      }
    },
    /**
     * 获取数据列表
     * **/

    getList(value, num) {
      this.loading = true
      let params = {
        NAME: value,
        EMPLID: sessionStorage.getItem('EMPLID'),
        DEPTID: this.departmentStr,
      }
      getMyTeamIndexApi(params).then((res) => {
        if (res.CODE == 200) {
          let subBodys = res.DATA
          this.maxPageNo = parseInt(res.DATA.MAXPAGE)
          if (this.currentPageNo >= this.maxPageNo) {
            this.loadFinished = true
          } else {
            this.loadFinished = false
          }
          if (this.currentPageNo == 1) {
            //如果当前是第一页，清空相关数据
            this.subBody = []
          }

          this.subBody = this.subBody.concat(subBodys)
          // this.subBody.forEach((item) => {
          //   item.PHOTO = item.PHOTO.replace(/<br>/g, '')
          // })
          this.loading = false
        }
      })
    },
  },
  components: {
    toptitle,
    Department,
    history,
    Index,
    List,
    Result,
  },
  created() {
    // 定义数组接收本地存储的历史记录
    let history = localStorage.hislist
    if (history) {
      // 将数组转字符串
      this.hislist = JSON.parse(history)
    }
  },
}
</script>

<style lang="less" scoped>
/deep/.van-search {
  background: #efeff4;
  margin-bottom: 10px;
  border-bottom: 1px solid #e5e5e5;
}
</style>